<div class="container-fluid bg-n2 p-3">
  <div>
    <div class="row mt-3">
      <div class="col"><h2 class="text-n5">Your Suggestions:</h2></div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card mb-3 h-100">
        <div class="row g-0">
          <div class="col-4">
            <img src="/assets/images/menu-items/coffee.png" class="img-fluid rounded-start" />
          </div>
          <div class="col-8">
            <div class="card-body mt-2">
              <h3 class="card-title text-n5">Fresh Brewed Coffee</h3>
              <h3 class="card-text text-n5">
                $1.79
                <span class="sub-heading3 text-n4">| 5 cal</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card mb-3 h-100">
        <div class="row g-0">
          <div class="col-4">
            <img src="/assets/images/menu-items/honey-biscuit.png" class="img-fluid rounded-start" />
          </div>
          <div class="col-8">
            <div class="card-body mt-2">
              <h3 class="card-title text-n5">Honey Butter Chicken Buscuit</h3>
              <h3 class="card-text text-n5">
                $2.59
                <span class="sub-heading3 text-n4">| 500 cal</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col sub-heading2">Subtitle Text 2</div>
    <div class="col sub-heading4">Subtitle Text 4</div>
  </div>
  <div class="row">
    <div class="col paragraph-large">Paragraph 2</div>
    <div class="col paragraph-medium paragraph-bold">Paragraph 4 Bold</div>
  </div>
</div>
